export default __webpack_public_path__ + "static/media/hero_bg.4496ec76.jpg";